// src/components/Assets/AssetCard.js
// Individual asset card component with actions

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaEdit, FaTrash, FaDollarSign, FaTools } from "react-icons/fa";
import PropTypes from "prop-types";
import "./style.css";

const AssetCard = ({ asset, onEdit, onDelete, onAddExpense, canEdit, canDelete }) => {
  const [t] = useTranslation();
  const [showActions, setShowActions] = useState(false);

  return (
    <div
      className="asset-card"
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      {/* Card Header */}
      <div className="asset-card-header">
        <div className="asset-icon">
          <FaTools />
        </div>
        {(canEdit || canDelete) && (
          <div className={`asset-actions ${showActions ? "visible" : ""}`}>
            {canEdit && (
              <button
                className="action-btn edit-btn"
                onClick={() => onEdit(asset)}
                title={t("Edit")}
              >
                <FaEdit />
              </button>
            )}
            {canDelete && (
              <button
                className="action-btn delete-btn"
                onClick={() => onDelete(asset)}
                title={t("Delete")}
              >
                <FaTrash />
              </button>
            )}
          </div>
        )}
      </div>

      {/* Card Body */}
      <div className="asset-card-body">
        <h3 className="asset-name" title={asset.name}>
          {asset.name}
        </h3>
        <p className="asset-details">{asset.details}</p>
      </div>

      {/* Card Footer */}
      {onAddExpense && (
        <div className="asset-card-footer">
          <button
            className="button-secondary button-secondary-sm"
            onClick={() => onAddExpense(asset)}
          >
            <FaDollarSign /> {t("Add Expense")}
          </button>
        </div>
      )}
    </div>
  );
};

// PropTypes validation
AssetCard.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string.isRequired,
    details: PropTypes.string
  }).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onAddExpense: PropTypes.func,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool
};

// Default props
AssetCard.defaultProps = {
  canEdit: true,
  canDelete: true,
  onAddExpense: null,
  onEdit: () => {},
  onDelete: () => {}
};

export default AssetCard;
